import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-botones',
  templateUrl: './botones.component.html',
  styleUrls: ['./botones.component.scss']
})
export class BotonesComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'simbolicos',
        titulo: 'Botones Simbólicos',
        subtitulo: 'Compuesto por un icono que representa gráficamente una acción y opcionalmente puede estar acompañado de un título que describe la acción del botón.',
        componentRender: `
        <p>Elementos button</p>
        <!-- Botón con símbolo y texto centrado -->
        <button type="button" class="btn-symbolic-govco align-column-govco">
            <span class="govco-icon govco-icon-print-p"></span>
            <span class="btn-govco-text">Imprimir</span>
        </button>
        <!-- Texto alineado a la derecha -->
        <button type="button" class="btn-symbolic-govco">
                <span class="govco-icon govco-icon-print-p"></span>
                <span class="btn-govco-text textright-govco">Imprimir</span>
            </button>
        <!-- Botón solo símbolo, incluir atributo aria-label y title -->
        <button type="button" class="btn-symbolic-govco" aria-label="Imprimir documento" title="Imprimir documento">
            <span class="govco-icon govco-icon-print-p"></span>
        </button>
        <!-- Botón inactivo -->
        <button type="button" class="btn-symbolic-govco inactive">
                <span class="govco-icon govco-icon-print-p"></span>
                <span class="btn-govco-text textright-govco">Imprimir</span>
            </button>
        <p>Elementos a</p>
        <!-- Enlace con símbolo y texto centrado -->
        <a href="/" class="btn-symbolic-govco align-column-govco">
                <span class="govco-icon govco-icon-print-p"></span>
                <span class="btn-govco-text">Imprimir</span>
            </a>
        <!-- Enlace con texto alineado a la derecha. Debido al propósito de la acción se incluye el role = button -->
        <a href="/" class="btn-symbolic-govco" role="button">
                <span class="govco-icon govco-icon-print-p"></span>
                <span class="btn-govco-text textright-govco">Imprimir</span>
            </a>
        <!-- Enlace solo símbolo, incluir atributo aria-label y title -->
        <a href="/" class="btn-symbolic-govco" role="button" aria-label="Imprimir documento" title="Imprimir documento">
            <span class="govco-icon govco-icon-print-p"></span>
        </a>
        <!-- Enlace inactivo -->
        <a href="/" class="btn-symbolic-govco inactive">
                <span class="govco-icon govco-icon-print-p"></span>
                <span class="btn-govco-text textright-govco">Inicio</span>
            </a>
`,
      },
      {
        id: 'textuales',
        titulo: 'Botones textuales',
        subtitulo: 'No tienen icono, describen la acción por medio de texto de no mayor a 3 palabras, salvo en contenidos específicos.',
        componentRender: `<!-- Botones Activos -->
  <p> Botones activos </p>
  <a href="/" class="btn btn-round btn-high">Botón</a>
  <a href="/" class="btn btn-round btn-middle">Botón</a>
  <a href="/" class="btn btn-low">Botón</a>
  <p> Botones inactivos </p>
  <a href="/" class="btn btn-round btn-high inactive">Botón</a>
  <a href="/" class="btn btn-round btn-middle inactive">Botón</a>
  <a href="/" class="btn btn-low inactive ">Botón</a>
`,
      }, {
        id: 'mixtos',
        componentRender: `
<p>Botones mixtos </p>
<div class="row">
<!-- Botón con icono a la izquierda -->
  <button type="button" class="btn btn-round btn-high-mix-govco">           
    <span class="govco-icon govco-icon-pin icon-reverse-x text-white"></span>	
    <span class="btn-govco-text text-white">Ubicación</span>
  </button>
  <!-- Botón con icono a la derecha -->
  <button type="button" class="btn btn-round btn-high-mix-govco">           	
    <span class="btn-govco-text text-white">Búsqueda general</span>
    <span class=govco-icon govco-icon-right-arrow text-white"></span>
  </button>
  <!-- Botón mixto inactivo -->
  <button type="button" class="btn btn-round btn-high-mix-govco btn-high-inactive">           	
    <span class="btn-govco-text text-white">Búsqueda general</span>
    <span class="govco-icon govco-icon-right-arrow text-white"></span>
  </button>
</div>	

<p>Enlaces mixtos </p>
<div class="row">
  <a href="#" class="btn btn-low-mix-govco">
    <span class="btn-govco-text">Más información</span>
    <span class="govco-icon govco-icon-simpler-arrow"></span>
  </a>
  <a href="/" class="btn btn-low-mix-govco align-column-govco">
  <span class="btn-govco-text">Ver más detalles</span>
  <span class="govco-icon govco-icon-simpled-arrow"></span>
  </a>
  <!-- Botón mixto inactivo -->
  <a href="/" class="btn btn-low-mix-govco align-column-govco inactive">
  <span class="btn-govco-text">Ver más detalles</span>
  <span class="govco-icon govco-icon-simpled-arrow"></span>
  </a>
</div>`,
        titulo: 'Botones mixtos',
        subtitulo: 'Compuestos por el texto que describe la acción y un icono. Sin embargo a diferencia del botón simbólico, en éste el texto tiene mayor importancia.'
      }, 
    ]

    this.infoComponent = {
      titulo: "Botones",
      descripcion: "Los botones permiten realizar una acción de ejecución o dirigen al usuario a otro contenido dentro del sitio o fuera de él. A continuación se describen los diferentes estilos definidos para este elemento de acuerdo con su propósito semántico."
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }
}



